(() => {

  const pageFooter = document.querySelector("html > body > div > footer.footer");
  const newsLetterBlock = pageFooter?.querySelector(".footer-block--newsletter");
  const footerBlocksWrapper = pageFooter?.querySelector(".footer__blocks-wrapper");
  const footerFirstBlock = footerBlocksWrapper?.querySelector(":first-child");
  if(pageFooter && newsLetterBlock && footerBlocksWrapper && footerFirstBlock) {
    newsLetterBlock.remove();
    footerFirstBlock.appendChild(newsLetterBlock);
    newsLetterBlock.style.display = "unset";
  }
})();
